// client/src/services/therapistService.js
import axios from '../utils/axiosConfig';

export const getMyProfile = () => axios.get('/therapist/profile').then(r => r.data.profile);
export const updateMyProfile = (data) => axios.put('/therapist/profile', data).then(r => r.data.profile);
export const submitVerificationDocuments = (documents) =>
  axios.post('/therapist/verification-documents', { documents }).then(r => r.data.profile);
export const setAvailability = (availabilityStatus) =>
  axios.put('/therapist/availability', { availabilityStatus }).then(r => r.data.profile);
export const getPendingOffer = () => axios.get('/therapist/orders/offers').then(r => r.data.offer);
export const acceptOrder = (orderId) => axios.post(`/therapist/orders/${orderId}/accept`).then(r => r.data.order);
export const declineOrder = (orderId) => axios.post(`/therapist/orders/${orderId}/decline`);
export const startSession = (orderId) => axios.post(`/therapist/orders/${orderId}/session/start`).then(r => r.data.order);
export const stopSession = (orderId) => axios.post(`/therapist/orders/${orderId}/session/stop`).then(r => r.data.order);
export const confirmCompletion = (orderId) =>
  axios.post(`/therapist/orders/${orderId}/confirm-completion`).then(r => r.data.order);
export const getMyOrders = () => axios.get('/therapist/orders').then(r => r.data.orders);
